module.exports = __webpack_public_path__ + "static/AntDesign-3a2ba31570920eeb9b1d217cabe58315.ttf";